import { http } from "./api-config";
import store from "../store";

const apiClient = http(process.env.VUE_APP_TASK_SERVICE);
export default {

    async getTasksList() {
        let headers = {};
        if (store.state.variables.cashTasksList) {
            headers = { "isSilentAPI": true };
        }
        store.commit('variables/setCashTasksList', true)
        const res = await apiClient.get(`taskslist`, { headers });
        return res.data;
    },
    async getTasksListWithoutCash() {
        const res = await apiClient.get(`taskslist`);
        return res.data;
    },
    async getTaskById(id) {
        const res = await apiClient.get(`tasks/${id}`);
        return res.data;
    },
    async createTask(data) {
        const res = await apiClient.post("tasks", data);
        return res.data;
    },
    async updateTask(data) {
        const res = await apiClient.put("tasks", data);
        return res.data;
    },
    async deleteTask(id) {
        const res = await apiClient.delete(`tasks/${id}`)
        return res.data
    },
    async updateTaskStatus(data) {
        const res = await apiClient.put("changeTaskStatus", data);
        return res.data;
    },
    async getTaskAssigneeDetails(taskId) {
        const res = await apiClient.get(`task-assignees-details/${taskId}`)
        return res.data;
    },
    async saveTaskDocuments(data) {
        const headers = { "Content-Type": "multipart/form-data" };
        const res = await apiClient.post("task_documents", data, {
          headers,
        });
        
        return res.data;
      },

      async downloadTaskDocument(id, filename) {
        const res = await apiClient.get(`task_document/${id}`, {
            responseType: "blob",
            fileName: filename,
        })
        return res
    },
    async deleteTaskDocument(id) {
        const res = await apiClient.delete(`task_documents/${id}`)
        return res.data
    },
}